import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { StoreType } from "../../../utils/types";
import {
	fetchSupervisorOverview,
	setRequestsWindowDays,
} from "../store/supervisor-home-slice";
import { buildOverviewParams } from "../utils/overview-params";

const useSupervisorHomeController = () => {
	const dispatch = useDispatch<any>(); // eslint-disable-line @typescript-eslint/no-explicit-any
	const requestsWindowDays = useSelector(
		(state: StoreType) => state.supervisorHome.requestsWindowDays
	);

	const refresh = useCallback(() => {
		dispatch(fetchSupervisorOverview(buildOverviewParams(requestsWindowDays)));
	}, [dispatch, requestsWindowDays]);

	const changeRequestsWindow = useCallback(
		(days: number) => {
			dispatch(setRequestsWindowDays(days));
		},
		[dispatch]
	);

	// Refetches whenever the requests window changes — it is a server-side
	// param, not a client-side filter.
	useEffect(() => {
		refresh();
	}, [refresh]);

	return { refresh, requestsWindowDays, changeRequestsWindow };
};

export default useSupervisorHomeController;
